import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FormattedCurrency } from '../../components/formatted-currency';
import { UserDateTimezoneFormat } from '../../components/user-date-timezone-format';
import LabelWithValue from './label-with-value';

import messages from './messages';
import style from './style.module.less';

const Overview = ({ orderNumber, overview }) => {
  return (
    <div className={style['overview-grid']}>
      <div>
        <div className={style['header-label']}>
          <FormattedMessage {...messages.overview} />
        </div>
        <div className={style['overview-values']}>
          <LabelWithValue label={<FormattedMessage {...messages.orderNumberLabel} />} value={orderNumber} />
          <LabelWithValue
            label={<FormattedMessage {...messages.totalShippingPriceLabel} />}
            value={<FormattedCurrency currencyCode={overview.totalCharges.code} value={overview.totalCharges.value} />}
          />
          <LabelWithValue
            label={<FormattedMessage {...messages.createdLabel} />}
            value={<UserDateTimezoneFormat dateTime={overview.createdAt} showTime spaceBetweenTimeAndZone />}
          />
        </div>
      </div>
      <div>
        <div className={style['header-label']}>
          <FormattedMessage {...messages.customerSelectedShipping} />
        </div>
        <div className={style['overview-values']}>
          <LabelWithValue label={<FormattedMessage {...messages.carrierTitleLabel} />} value={overview.carrierTitle} />
          <LabelWithValue label={<FormattedMessage {...messages.methodLabel} />} value={overview.methodTitle} />
        </div>
      </div>
    </div>
  );
};

Overview.propTypes = {
  orderNumber: PropTypes.string.isRequired,
  overview: PropTypes.shape({
    carrierTitle: PropTypes.string,
    totalCharges: PropTypes.number,
    methodTitle: PropTypes.string,
    createdAt: PropTypes.string,
  }).isRequired,
};

export default Overview;
